const { base_url } = require("Constants");
import log from "loglevel";

export const addBaseUrl = (url) => {
    try {
        if (url?.includes?.("//")) {
            url = url.split("//")[1];

            let position = url.indexOf('/');
            if (position === -1) {
                position = url.length - 1;
            }
            url = url?.substring?.(position + 1) || "";
            let baseUrl = base_url;
            if (baseUrl.charAt(baseUrl.length - 1) === '/') {
                // do nothing
            } else {
                baseUrl += "/";
            }

            url = baseUrl + url;

            return url;
        }
        return url;
    } catch (err) {
        log.error(err);
        return url;
    }
}